import { useMemo } from 'react'
import { SelectOption } from '../../../../../../model/selectOption'
import { useTeamSelectData } from './useTeamSelectData'

type UseTeamSelectOptionsProps = {
  snapshotUuid: string
  selectedUuids: string[]
}

type TeamSelectOptions = {
  options: SelectOption[]
  parentMap: Record<string, string>
}

export const useTeamSelectOptions = ({
  snapshotUuid,
  selectedUuids,
}: UseTeamSelectOptionsProps): TeamSelectOptions => {
  const { rows } = useTeamSelectData({ snapshotUuid, selectedUuids })

  return useMemo(() => {
    const options: SelectOption[] = rows.map(row => ({
      value: row.uuid,
      name: row.displayName,
    }))
    return { options, parentMap: {} }
  }, [rows])
}
